module.exports = __webpack_public_path__ + "static/media/cyber.e1a80852.svg";